//don't add any newlines between the tick marks, otw you'll get a blank item in the bucket of texts
const letterText_fr = `A
À
Â
B
C
Ç
D
E
È
Ê
É
F
G
H
I
J
K
L
M
N
O
P
Q
R
S
T
U
Ù
V
W
X
Y
Z`;
export default letterText_fr;